import React, { useState, useEffect } from "react";
import BaseEmailComponent from "../BaseEmailComponent";

const Button = ({ id, data, onUpdate, styleSettings, previewMode }) => {
  // Extract data with fallbacks
  const extractData = () => {
    const title = data?.title || data?.text || data?.label || "Button";
    const link = data?.link || data?.url || data?.href || "#";
    const buttonColor = data?.button_color || data?.buttonColor || styleSettings?.primaryColor || "#007bff";
    const textColor = data?.text_color || data?.textColor || styleSettings?.buttonTextColor || "#ffffff";
    
    return { title, link, buttonColor, textColor };
  };

  // Extract initial values
  const { title: initialTitle, link: initialLink, buttonColor: initialBtnColor, textColor: initialTextColor } = extractData();
  
  // State hooks at component level
  const [buttonLink, setButtonLink] = useState(initialLink);
  const [btnColor, setBtnColor] = useState(initialBtnColor);
  const [btnTextColor, setBtnTextColor] = useState(initialTextColor);
  const [buttonTitle, setButtonTitle] = useState(initialTitle);

  // Update local state when props change
  useEffect(() => {
    const { title, link, buttonColor, textColor } = extractData();
    setButtonTitle(title);
    setButtonLink(link);
    setBtnColor(buttonColor);
    setBtnTextColor(textColor);
  }, [data, styleSettings]);

  // Handle update
  const handleUpdate = (updatedData) => {
    if (onUpdate) {
      onUpdate({
        ...data,
        ...updatedData,
        component_name: data?.component_name || "Button"
      }, id);
    }
  };

  // Update button properties when saving changes
  const saveButtonChanges = () => {
    handleUpdate({
      title: buttonTitle,
      link: buttonLink,
      button_color: btnColor,
      text_color: btnTextColor
    });
  };

  // Edit UI - this gets passed props from BaseEmailComponent, but we use our local state instead
  const renderEditUI = (props) => {
    return (
      <div className="p-3 rounded bg-white">
        <div className="mb-3">
          <label className="form-label fw-bold">Button Text</label>
          <input
            type="text"
            className="form-control"
            value={buttonTitle}
            onChange={(e) => setButtonTitle(e.target.value)}
            onBlur={saveButtonChanges}
          />
        </div>
        <div className="mb-3">
          <label className="form-label fw-bold">Button Link</label>
          <input
            type="text"
            className="form-control"
            value={buttonLink}
            onChange={(e) => setButtonLink(e.target.value)}
            onBlur={saveButtonChanges}
            placeholder="https://..."
          />
        </div>
        <div className="row">
          <div className="col-6 mb-3">
            <label className="form-label fw-bold">Button Color</label>
            <div className="d-flex align-items-center">
              <input
                type="color"
                className="form-control form-control-color me-2"
                value={btnColor}
                onChange={(e) => setBtnColor(e.target.value)}
                onBlur={saveButtonChanges}
              />
              <input
                type="text"
                className="form-control"
                value={btnColor}
                onChange={(e) => setBtnColor(e.target.value)}
                onBlur={saveButtonChanges}
              />
            </div>
          </div>
          <div className="col-6 mb-3">
            <label className="form-label fw-bold">Text Color</label>
            <div className="d-flex align-items-center">
              <input
                type="color"
                className="form-control form-control-color me-2"
                value={btnTextColor}
                onChange={(e) => setBtnTextColor(e.target.value)}
                onBlur={saveButtonChanges}
              />
              <input
                type="text"
                className="form-control"
                value={btnTextColor}
                onChange={(e) => setBtnTextColor(e.target.value)}
                onBlur={saveButtonChanges}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  // View UI - this gets passed props from BaseEmailComponent, but we use our local state instead
  const renderViewUI = (props) => {
    return (
      <a
        href={buttonLink}
        target="_blank"
        rel="noopener noreferrer"
        className="btn px-4 py-2"
        style={{
          backgroundColor: btnColor,
          color: btnTextColor,
          borderRadius: "4px",
          textDecoration: "none",
          border: "none",
          fontWeight: "500",
          cursor: "pointer",
          display: "inline-block",
          textAlign: "center"
        }}
      >
        {buttonTitle}
      </a>
    );
  };

  return (
    <BaseEmailComponent
      id={id}
      data={{...data, title: buttonTitle}}
      onUpdate={onUpdate}
      componentName="Button"
      styleSettings={styleSettings}
      editUI={renderEditUI}
      viewUI={renderViewUI}
      previewMode={previewMode}
    />
  );
};

export default Button; 